export default "__VITE_ASSET__C95r_Rnt__"